import React, {useContext, useEffect} from 'react';
import {Grid} from "@material-ui/core";
import PriorAuthorizationContext from "../../../../contexts/PriorAuthorization/PriorAuthorization.context";
import PaFormSteps from "../../../../shared/PaFormSteps";
import PaFormFields from "../../../../shared/PaFormFields";
import AppContext from "../../../../contexts/App/App.context";
import Divider from "@material-ui/core/Divider";
import useStyles from "./styles";
import CompoundViewTable from "../InputTypes/CompoundViewTable";
import FormFieldLabel from "../FormFieldLabel";
import FormFieldValue from "../FormFieldValue";

export default function FormBody(props) {

    const {removeCompounds, ...wrapperProps} = props

    const classes = useStyles();

    // get app values from the app config
    const {npiNumber, provider: {providerFirstName, providerLastName, providerType, providerPhone, providerFax, providerNameType }} = useContext(AppContext);

    // get the context for the form, includes data values, validation data and stepper state
    const context = useContext(PriorAuthorizationContext);
    const {create: {currentStep}, setBanner, fields, setFields} = context;
    const stepConfig = PaFormSteps[currentStep];
    useEffect(() => {
      const providerName = `${providerFirstName || ""}${
        providerFirstName ? " " : ""
      }${providerLastName || ""}`;
      if (providerNameType && providerNameType === "Business") {
        stepConfig.fields[1] = ["providerPhone"];
      } else {
        stepConfig.fields[3] = [];
        stepConfig.fields[4] = [];
      }
      if (currentStep === 5 && stepConfig?.fields?.length === 2) {
            stepConfig.fields.splice(1, 1)
      }
      setFields({
        npiNumber,
        providerName,
        providerType,
        providerPhone,
        providerFax,
      });
      // eslint-disable-next-line
    }, [
      npiNumber,
      providerFirstName,
      providerLastName,
      providerType,
      providerPhone,
      providerFax,
    ]);

    // get the current step from the steps config
    

    // each field uses onchange
    const onChange = (e, isDirty=false, configType) => {

        if (e.target.name === "prescriberNPI" || e.target.name === "ndcInput") {
            const numericValue = e.target.value.replace(/\D/g, '');
            if (e.target.value !== numericValue) {
                e.target.value = numericValue
            }
        }
        
        onUpdate({e, updateType: 'onChange', isDirty, configType})
    }

    const handleNumberChange = (e, isDirty=false, configType) => {
        let input = e.target.value;

        input = input.replace(/[^0-9.]/g, '');

        const parts = input.split('.');
        if (parts.length > 2) {
            input = parts[0] + '.' + parts[1];
        }

        parts[0] = parts[0].slice(0,7);

        if (parts.length === 2) {
            parts[1] = parts[1].slice(0, 3);
            input = parts[0] + '.' + parts[1];
        } else {
            input = parts[0];
        }

        e.target.value = input;

        onUpdate({e, updateType: 'handleNumberChange', isDirty, configType})
    }

    // each field uses onblur, checkboxes call onblur when clicked
    const onBlur = (e, configType) => {
        onUpdate({e, updateType: 'onBlur', isDirty: true, configType})
    }

    // update the context for blur or change
    const onUpdate = params => {
        const {e: {target: {name, value}}, updateType, isDirty} = params;
        let cb = null;
        if (name === undefined || value === undefined) {
            return;
        }

        if (PaFormFields[name][`before${updateType}`]) {
            const beforeCheck = PaFormFields[name][`before${updateType}`](value, context, props);
            if (!beforeCheck) {
                return;
            }
        }

        if (PaFormFields[name][`after${updateType}`]) {
            cb = PaFormFields[name][`after${updateType}`]
        }

        // recalculate isDirty based on event type
        const _isDirty = updateType === 'onBlur' ? true : isDirty ? true : fields[name].isDirty

        setFields({[name]: {value, isDirty: _isDirty}}, cb);

        if (PaFormFields[name][updateType]) {
            PaFormFields[name][updateType](value, context)
        }
    }

    // check if we are on last step and need to show summary style
    const isLastStep = PaFormSteps[currentStep].title === 'SUMMARY'

    const customComponents = {
        separator: row  => <Grid key={row} item xs={12} className={classes.marginTop}><Divider /></Grid>,
        compoundsDisplay: row => <CompoundViewTable compounds={fields.compounds.value} row={row} style={classes.compoundViewTable} />
    }

    // Render
    return (
        <div
            id='MEDCAL_RX_CREATE_PA_FORM_BODY'
            data-testid='MEDCAL_RX_CREATE_PA_FORM_BODY'
            {...wrapperProps}
            style={{width: '100%', ...wrapperProps.style}}
        >
            <Grid container spacing={1}>
                {stepConfig.fields.map((fieldsRow, row) => {
                    return (
                            <Grid container spacing={1} item xs={12} key={`${row}`}>
                                {fieldsRow.map((field, key) => {

                                    const fieldConfig = PaFormFields[field];
                                    const {label, visibility, fieldBreakpoints, type} = {...PaFormFields[field]};

                                    const isVisible = !visibility || (visibility && visibility(fields));
                                    const isCustomComponent = customComponents[field] ? true : !!customComponents[type];

                                    if (!isVisible || (!isCustomComponent && !fieldConfig)) {
                                        return <></>;
                                    }

                                    const labelProps = {
                                        field,
                                        fieldConfig,
                                        isLastStep
                                    }

                                    const valueProps = {
                                        field,
                                        fieldConfig,
                                        fields,
                                        onBlur: (e) => onBlur(e, type),
                                        onChange,
                                        handleNumberChange,
                                        setBanner
                                    }

                                    const fieldProps = {
                                        container: true,
                                        id: `field_row_${field}`,
                                        item: true,
                                        key,
                                        spacing: 1,
                                        xs: 12,
                                        ...fieldBreakpoints
                                    }

                                    /* Custom Components:
                                    * 1. Can be specific to an exact field
                                    * 2. Can be a type
                                    * */
                                    let getCustomComponent;
                                    if (isVisible && customComponents[field]) {
                                        getCustomComponent = customComponents[field];
                                    }
                                    if (isVisible && customComponents[type]) {
                                        getCustomComponent = customComponents[type];
                                    }
                                    if (getCustomComponent) {
                                        return getCustomComponent(row);
                                    }

                                    return <Grid {...fieldProps} style={field === "enteralNdc" ? {'margin-top': '-350px', 'height': '50px'} : {}}>
                                        {label && <FormFieldLabel {...labelProps} />}
                                        <FormFieldValue {...valueProps}  />
                                    </Grid>;
                                })}
                            </Grid>
                    )
                })}
            </Grid>
        </div>
    )
}